module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list', [_vm._l((_vm.menuItems), function(item) {
    return [(item.heading) ? _c('v-layout', {
      key: item.heading,
      attrs: {
        "row": "",
        "align-center": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs6": ""
      }
    }, [(item.heading) ? _c('v-subheader', [_vm._v("\n                " + _vm._s(item.heading) + "\n              ")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
      staticClass: "text-xs-center",
      attrs: {
        "xs6": ""
      }
    }, [_c('a', {
      staticClass: "body-2 black--text",
      attrs: {
        "href": "#!"
      }
    }, [_vm._v("EDIT")])])], 1) : (item.children) ? _c('v-list-group', {
      key: item.text,
      attrs: {
        "prepend-icon": item.model ? item.icon : item['icon-alt'],
        "append-icon": "",
        "value": "item.active"
      },
      model: {
        value: (item.model),
        callback: function($$v) {
          _vm.$set(item, "model", $$v)
        },
        expression: "item.model"
      }
    }, [_c('v-list-tile', {
      attrs: {
        "slot": "activator"
      },
      slot: "activator"
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "to": item.action
      }
    }, [_vm._v("\n                  " + _vm._s(item.text) + "\n                ")])], 1)], 1), _vm._v(" "), _vm._l((item.children), function(child, i) {
      return _c('v-list-tile', {
        key: i,
        on: {
          "click": function($event) {}
        }
      }, [(child.icon) ? _c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(child.icon))])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                  " + _vm._s(child.text) + "\n                ")])], 1)], 1)
    })], 2) : _c('v-list-tile', {
      key: item.text,
      attrs: {
        "to": item.action
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                " + _vm._s(item.text) + "\n              ")])], 1)], 1)]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f91ef38","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Menu.vue
// module id = 357
// module chunks = 4